// src/components/StudentReceipt.js
import React, { useEffect } from 'react';
import styles from '../../../css/Acknowledgement.module.css'
import Barcode from 'react-barcode';
import { useDispatch, useSelector } from 'react-redux';
import { readSchools } from '../../../store/actions/schoolActions';
import { fetchLogo  } from '../../../store/actions/logoActions';

const StudentReceipt = React.forwardRef(({ currDetail, receiptData }, ref) => {

  const dispatch = useDispatch();
  const { schools, loading, error } = useSelector((state) => state.schoolDetails);
  // console.log(currDetail);
 
  const { logoUrl } = useSelector((state) => state.logo);
   // Fetch the logo on component mount
  useEffect(() => {
    dispatch(fetchLogo());
  }, [dispatch]);

  useEffect(() => {
    dispatch(readSchools());
  }, [dispatch]);
  
  const imageUrl = logoUrl;
  const barcodeImage = <Barcode value={currDetail.student_uid} width={0.97} height={35} />; 

  //get current date
  const today = new Date();
  const currentDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
  const startYear = today.getFullYear();
  const endYear = startYear + 1;
  const session = `${startYear}-${endYear}`;
  
  return (
    <div className={styles.Acknowledgement} ref={ref}>
        <div className={styles.page}>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none' }}>
            <tbody>
              <tr style={{ border: 'solid windowtext 1.0pt' }}>
                <td style={{ width: '95.65pt', border: 'none', padding: '0cm 5.4pt', height: '47.55pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                    <img src={imageUrl} alt='Logo' width={70} />
                  </p>
                </td>
                <td colSpan="3" style={{ width: '322.3pt', border: 'none', padding: '0cm 5.4pt', height: '47.55pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center', lineHeight: '107%' }}>
                    <strong>
                      <span style={{ fontSize: '21px', lineHeight: '107%' }}>
                      {schools && schools.length > 0 ? (
                          schools.map((school, index) => (
                            <div key={index}>
                              <h3><span style={{color: '#003366'}}><strong> {school.school_name} </strong></span></h3>
                              <p>
                              <span style={{color: '#003366'}}>
                                {school.city}, {school.district}, {school.state}, {school.postal_code}<br />
                                <strong>Contact: {school.contact_number}</strong>
                              </span>                          
                              </p>
                            </div>
                          ))
                        ) : (
                          <>
                            <h3><span style={{color: '#003366'}}><strong>School Name</strong></span></h3>
                              <p>
                                <span style={{color: '#003366'}}>
                                  <strong>Address</strong><br />
                                  <strong>Contact: +91-xxxxx-xxxxx</strong>
                                </span>
                              </p>
                          </>
                        )}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '120.15pt', border: 'none', padding: '0cm 5.4pt', height: '47.55pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                    <strong>Serial No:{startYear}/{currDetail.student_id}</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="5" style={{ width: '528.1pt', borderWidth: 'medium 1pt 1pt', borderStyle: 'none solid solid', borderColor: 'currentcolor windowtext windowtext', backgroundColor: 'rgb(244, 176, 131)', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ display:'flex',justifyContent:'space-between', fontSize: '16px', color: 'black' }}>
                        <p style={{color: 'black'}}>Student Detail (Academic Session -{startYear})</p>
                        <p style={{color:'black'}}>{currentDate}</p>
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Full Name
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.full_name}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        DOB
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.dob}
                      </span>
                    </strong>
                  </p>
                </td>
                <td rowSpan="5" style={{ width: '120.15pt', borderWidth: 'medium 1pt 1pt medium', borderStyle: 'none solid solid none', borderColor: 'currentcolor windowtext windowtext currentcolor', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                   <p style={{ margin: '14px', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>
                        <img src={currDetail.pass_photo} alt="Student" width={100} />
                        <br />
                        {barcodeImage}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Gender
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        {currDetail.sex ==='male'?'Male':'Female'}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Admitted to
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.class_admitted}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        PEN
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.pen}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Aadhar
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.aadhar_no}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Father’s Name
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.father_name}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Mother’s Name
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.mother_name}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Religion
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.religion}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Nationality
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.nationality}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              {/* sdjgsdjfhsdhf */}
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        State   
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.state}    
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        District
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.district}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.pincode}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Address for Communication</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '226.1pt', border: 'solid windowtext 1.0pt', borderLeft: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}> {currDetail.r_address}</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', border: 'solid windowtext 1.0pt', borderLeft: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Contact No:</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '120.15pt', border: 'solid windowtext 1.0pt', borderLeft: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>{currDetail.contact_no}</span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="5" style={{ width: '528.1pt', border: 'solid windowtext 1.0pt', borderTop: 'none', background: '#F4B083', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px', color: 'black' }}>Payment Details</span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Date:</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>{currentDate}</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Total Amount</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '206.35pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <span style={{ fontSize: '16px' }}>{receiptData.net_amt}</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Amount Paid</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>{receiptData.paying_amt}</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Fees Up To</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '206.35pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <span style={{ fontSize: '16px' }}></span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Transaction ID</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Offline</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Payment Method:</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '206.35pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <span style={{ fontSize: '16px' }}>Cash</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="2" style={{ width: '223.85pt', borderWidth: 'medium 1pt 1pt', borderStyle: 'none solid solid', borderColor: 'currentcolor windowtext windowtext', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Amount Outstanding</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="3" style={{ width: '304.25pt', borderWidth: 'medium 1pt 1pt medium', borderStyle: 'none solid solid none', borderColor: 'currentcolor windowtext windowtext currentcolor', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <span style={{ fontSize: '16px' }}>{receiptData.balance_amt}</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>   
          {/* Scisor line  */}
         
        <div className={styles.cuttingLine}>
          <span className={styles.scissors}>✂️</span>
        </div>
          {/* end scissor cutting line  */}
        <div className='d-flex justify-content-between align-item-center' style={{marginTop:'50px'}}>
          <div className='d-flex justify-content-centre align-item-center'>
            <p>Office use</p>
          </div>
          <div className='tile'>
            <p><span style={{color: '#003366'}}><strong>For School</strong></span></p>
          </div>
          <div className="d-flex justify-content-end">
            <p className='text-danger'>Serial No.: {currDetail.student_id}</p>
          </div>
        </div>

        {/* for office use  */}
        <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none',paddingTop:'2px' }}>
            <tbody>
              <tr style={{ border: 'solid windowtext 1.0pt' }}>
                <td style={{ width: '95.65pt', border: 'none', padding: '0cm 5.4pt', height: '47.55pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                    <img src={imageUrl} alt='Logo' width={70} />
                  </p>
                </td>
                <td colSpan="3" style={{ width: '322.3pt', border: 'none', padding: '0cm 5.4pt', height: '47.55pt' }}>
                  {schools && schools.length > 0 ? (
                      schools.map((school, index) => (
                        <div key={index}>
                          <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center', lineHeight: '107%' }}>
                            <strong>
                              <span style={{ fontSize: '21px', lineHeight: '107%' }}> {school.school_name} </span>
                            </strong>
                          </p>
                          <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                            {school.city}, {school.district}, {school.state}, {school.postal_code}
                          </p>
                          <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                            Contact: {school.contact_number}
                          </p>
                        </div>
                      ))
                    ) : (
                      <>
                        <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center', lineHeight: '107%' }}>
                            <strong>
                              <span style={{ fontSize: '21px', lineHeight: '107%' }}>
                                School Name 
                              </span>
                            </strong>
                          </p>
                          <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                            Address: 
                          </p>
                          <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                            Contact No: +91-987456320
                          </p>
                      </>
                    )}
                </td>
                <td style={{ width: '120.15pt', border: 'none', padding: '0cm 5.4pt', height: '47.55pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                    <strong>Serial No:{currDetail.student_id}</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="5" style={{ width: '528.1pt', borderWidth: 'medium 1pt 1pt', borderStyle: 'none solid solid', borderColor: 'currentcolor windowtext windowtext', backgroundColor: 'rgb(244, 176, 131)', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ display:'flex',justifyContent:'space-between', fontSize: '16px', color: 'black' }}>
                        <p style={{color: 'black'}}>Student Detail (Academic Session -{startYear})</p>
                        <p style={{color:'black'}}>{currentDate}</p>
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Full Name
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.full_name}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        DOB
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.dob}
                      </span>
                    </strong>
                  </p>
                </td>
                <td rowSpan="5" style={{ width: '120.15pt', borderWidth: 'medium 1pt 1pt medium', borderStyle: 'none solid solid none', borderColor: 'currentcolor windowtext windowtext currentcolor', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                   <p style={{ margin: '14px', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>
                        <img src={currDetail.pass_photo} alt="Student" width={100} />
                        <br />
                        {barcodeImage}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Gender
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        {currDetail.sex ==='male'?'Male':'Female'}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Admitted to
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.class_admitted}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        PEN
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.pen}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Aadhar
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.aadhar_no}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Father’s Name
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.father_name}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Mother’s Name
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.mother_name}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Religion
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.religion}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        Nationality
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.nationality}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              {/* sdjgsdjfhsdhf */}
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        State
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.state}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                        District
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.district}
                      </span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '150%' }}>
                    <strong>
                      <span style={{ fontSize: '16px', lineHeight: '150%' }}>
                      {currDetail.pincode}
                      </span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Address for Communication</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '226.1pt', border: 'solid windowtext 1.0pt', borderLeft: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}> {currDetail.r_address}</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '96.2pt', border: 'solid windowtext 1.0pt', borderLeft: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Contact No:</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '120.15pt', border: 'solid windowtext 1.0pt', borderLeft: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>{currDetail.contact_no}</span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="5" style={{ width: '528.1pt', border: 'solid windowtext 1.0pt', borderTop: 'none', background: '#F4B083', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px', color: 'black' }}>Payment Details</span>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Date:</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>{currentDate}</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Total Amount</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '206.35pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <span style={{ fontSize: '16px' }}>{receiptData.net_amt}</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Amount Paid</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>{receiptData.paying_amt}</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Fees Up To</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '206.35pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '17.4pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <span style={{ fontSize: '16px' }}></span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ width: '95.65pt', border: 'solid windowtext 1.0pt', borderTop: 'none', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Transaction ID</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '128.2pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Offline</span>
                    </strong>
                  </p>
                </td>
                <td style={{ width: '97.9pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Payment Method:</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="2" style={{ width: '206.35pt', borderTop: 'none', borderLeft: 'none', borderBottom: 'solid windowtext 1.0pt', borderRight: 'solid windowtext 1.0pt', padding: '0cm 5.4pt', height: '35.65pt' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: 'normal' }}>
                    <span style={{ fontSize: '16px' }}>Cash</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="2" style={{ width: '223.85pt', borderWidth: 'medium 1pt 1pt', borderStyle: 'none solid solid', borderColor: 'currentcolor windowtext windowtext', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', textAlign: 'center', lineHeight: '35.0pt' }}>
                    <strong>
                      <span style={{ fontSize: '16px' }}>Amount Outstanding</span>
                    </strong>
                  </p>
                </td>
                <td colSpan="3" style={{ width: '304.25pt', borderWidth: 'medium 1pt 1pt medium', borderStyle: 'none solid solid none', borderColor: 'currentcolor windowtext windowtext currentcolor', padding: '0cm 5.4pt', height: '17.4pt', verticalAlign: 'top' }}>
                  <p style={{ margin: '0', fontSize: '12.0pt', fontFamily: '"Calibri", sans-serif', lineHeight: '35.0pt' }}>
                    <span style={{ fontSize: '16px' }}>{receiptData.balance_amt !==''?`${receiptData.balance_amt}`:'0'}</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table> 
      </div>          
    </div>
  );
});

export default StudentReceipt;
